var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouseOutlined1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bus_states",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#35ac25",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "warehouse"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30-2",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#08ccff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_610",
    "data-name": "Trac\\xE9 610",
    d: "M7,18H9V16H7Zm4,0h2V16H11ZM9,15h2V13H9ZM2,5.35l8-3.2,8,3.2V16H16V8H4v8H2ZM10,0,0,4V18H6V10h8v8h6V4Z",
    transform: "translate(2 3)",
    fill: "#08ccff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseOutlined1);
export default __webpack_public_path__ + "static/media/WarehouseOutlined-1.46963f0bf512463fbd3ab51d3775563c.svg";
export { ForwardRef as ReactComponent };